export default {
  vm: null,
  resetCacheTerm: null,
  resetCacheBot: null
}
